import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		boxShadow: 'none',
		color: '#00AAE8',
		marginTop: 20,
		border: '1px solid #00AAE8',
	},
	integrationTitle: {
		color: '#00AAE8',
	},
});
